<div class="text-white font-sans py-12 md:py-20 px-4 sm:px-6 lg:px-8 min-h-fit md:min-h-screen flex flex-col items-center justify-center overflow-hidden">
  
  <div class="w-full max-w-5xl mx-auto text-center italic mb-10 md:mb-16">
    <h1 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
      <span class="text-[#A6B1C2] font-semibold">Where</span>
      <span class="text-white font-extrabold"> Fun</span>
      <span class="text-[#A6B1C2] font-semibold"> Meets Real Rewards</span>
    </h1>

    <h2 class="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mt-2">
      <span class="text-[#A6B1C2] font-semibold">Discover</span>
      <span class="text-white font-extrabold"> Real Winning</span>
    </h2>

    <p class="mt-6 md:mt-8 text-gray-400 text-sm sm:text-base md:text-lg max-w-4xl mx-auto leading-relaxed px-2">
      At Real Winning, we believe games should be fun and rewarding. Our platform
      offers exciting games where players can test their luck and win real
      prizes while enjoying a seamless experience.
    </p>
  </div>

  <div class="w-full max-w-sm sm:max-w-2xl md:max-w-4xl lg:max-w-6xl mx-auto">
    <img loading="lazy"
      src="players.png"
      alt="Real Winning Players"
      class="w-full h-auto object-contain mx-auto transition-transform duration-300 hover:scale-[1.02]"
    />
  </div>
</div>